<app-layout>
  <div class="row">
    <div class="col-12">
      <div class="card p-0">
        <div class="card-header">
          <h3 class="card-title">Talep Onay Seviyeleri</h3>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="new()">Yeni</div>
          </div>
        </div>
        <div class="table-responsive" *ngIf="talepOnaySeviyeler">
          <table class="table card-table table-vcenter text-nowrap datatable">
            <thead>
            <tr>
              <th class="w-1">Id</th>
              <th>Talep Türü</th>
              <th>Kullanıcı Grubu</th>
              <th>Seviye</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let k of talepOnaySeviyeler">
              <td><span class="text-muted">{{k.id}}</span></td>
              <td>{{k.talepTur?.isim}}</td>
              <td>{{k.kullaniciGrup?.isim}}</td>
              <td>{{k.seviye}}</td>
              <td class="text-right">
                <div class="btn btn-sm btn-success" (click)="incele(k)">İncele</div>
                <div class="btn btn-sm btn-danger ml-3" (click)="kaldir(k)">Kaldır</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</app-layout>
